import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_10884_66074)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_10884_66074"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "12",
  height: "12",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 ${$props.width} ${$props.height}`,
    fill: "none"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M2 7.00313L2.78732 10.1524C2.80947 10.241 2.82054 10.2853 2.83363 10.3239C2.96158 10.7017 3.30176 10.9673 3.69926 10.9998C3.73995 11.0031 3.7856 11.0031 3.8769 11.0031C3.99122 11.0031 4.04838 11.0031 4.09654 10.9985C4.5725 10.9523 4.94917 10.5756 4.99533 10.0997C5 10.0515 5 9.99435 5 9.88002V2.75313M9.25 6.75313C10.2165 6.75313 11 5.96963 11 5.00313C11 4.03663 10.2165 3.25313 9.25 3.25313M5.125 2.75313H3.25C2.00736 2.75313 0.999999 3.76049 1 5.00313C1 6.24577 2.00736 7.25313 3.25 7.25313H5.125C6.00821 7.25313 7.08862 7.72657 7.92215 8.18095C8.40841 8.44603 8.65155 8.57857 8.81079 8.55906C8.95845 8.54098 9.0701 8.47468 9.15666 8.35368C9.25 8.2232 9.25 7.96213 9.25 7.43999V2.56627C9.25 2.04413 9.25 1.78305 9.15666 1.65257C9.0701 1.53158 8.95845 1.46528 8.81079 1.44719C8.65155 1.42769 8.40841 1.56023 7.92215 1.82531C7.08862 2.27969 6.00821 2.75313 5.125 2.75313Z",
    stroke: $props.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}